import * as types from './../types'
import { fetch } from '../../utils/http'
import apiSetting from './../bbnews-api'
import Vue from 'vue'

const state = {
  curUserNewsConfig: null,
  userNewsConfig: [],
  newsConfig: [],
  newsData: {}
}

const mutations = {
  // [types.SETTINGS_INIT_DATA]: (state, config) => {
  //   state.newsConfig = config
  // },
  [types.SETTINGS_NEWS_CONFIG]: (state, config) => {
    state.newsConfig = config
  },

  [types.SETTINGS_INIT_NEWS_GROUP]: (state, config) => {
    state.userNewsConfig = config
  },

  [types.SETTINGS_NEWS_GROUP_SWITCH]: (state, item) => {
    state.curUserNewsConfig = item
    localStorage.setItem(types.STORAGE_NEWS_CONFIG_TAB_ID, item.id)
  },

  [types.SETTINGS_NEWS_DATA]: (state, { newsTypeCode, newsTypeId, data }) => {
    Vue.set(state.newsData, newsTypeCode, data)
  },

  [types.SETTINGS_RESET]: state => {
    state.curUserNewsConfig = null
  }
}

const actions = {
  [types.SETTINGS_RESET]: content => {
    content.commit(types.SETTINGS_RESET)
  },

  [types.SETTINGS_INIT_DATA]: content => {
    content.dispatch(types.SETTINGS_INIT_NEWS_GROUP).then(response => {
      content.dispatch(types.USER_INIT_INFO)
    })
  },

  [types.SETTINGS_NEWS_GROUP_SWITCH]: (content, item) => {
    content.commit(types.SETTINGS_NEWS_GROUP_SWITCH, item)
    item.news_types.forEach(element => {
      content.dispatch(types.SETTINGS_NEWS_DATA, { newsTypeCode: element['code'], newsTypeId: element['id'] })
    })
  },

  [types.SETTINGS_INIT_NEWS_GROUP]: content => {
    return fetch(apiSetting.userNewsGroup.url).then(response => {
      content.commit(types.SETTINGS_INIT_NEWS_GROUP, response)
      var config = response[0]
      if (window.localStorage.getItem(types.STORAGE_NEWS_CONFIG_TAB_ID)) {
        var localConfigId = window.localStorage.getItem(types.STORAGE_NEWS_CONFIG_TAB_ID)
        var filterConfig = response.filter(item => {
          return item.id === parseInt(localConfigId)
        })
        if (filterConfig.length > 0) {
          config = filterConfig[0]
        }
      }
      content.dispatch(types.SETTINGS_NEWS_GROUP_SWITCH, config)
    })
  },

  [types.SETTINGS_NEWS_CONFIG]: content => {
    return fetch(apiSetting.newsConfig.url).then(response => {
      content.commit(types.SETTINGS_NEWS_CONFIG, response)
    })
  },

  [types.SETTINGS_NEWS_DATA]: (content, { newsTypeCode, newsTypeId }) => {
    return fetch(apiSetting.newsData.url + newsTypeId).then(response => {
      content.commit(types.SETTINGS_NEWS_DATA, {
        newsTypeCode: newsTypeCode,
        newsTypeId: newsTypeId,
        data: response
      })
    })
  }
}

export default {
  // namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js